import { t, Trans } from "@lingui/macro";

import { ToggleSwitch } from "@whoosh/design-system/src/components/controls";
import {
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

import { PreferencesType } from "./ManageNotifications";

type MyEventUpdatesProps = {
  preferences: PreferencesType;
  handleChange: (name: keyof PreferencesType) => void;
};

export const MyEventUpdates = ({
  preferences,
  handleChange,
}: MyEventUpdatesProps) => {
  return (
    <VStack gap={3}>
      <Text variant="mainTiny" color={"text-secondary"}>
        <Trans>MY EVENT UPDATES</Trans>
      </Text>
      <HStack justifyContent="space-between" alignItems="center">
        <Text variant="mainSmall">{t`Updates`}</Text>
        <ToggleSwitch
          name="eventUpdatesEnabled"
          onToggle={() => handleChange("eventUpdatesEnabled")}
          isChecked={preferences.eventUpdatesEnabled}
          isDisabled={false}
          accessibilityLabel={t`Toggle event update notifications`}
        />
      </HStack>
      <HStack justifyContent="space-between" alignItems="center">
        <Text variant="mainSmall">{t`Reminders`}</Text>
        <ToggleSwitch
          name="eventRemindersEnabled"
          onToggle={() => handleChange("eventRemindersEnabled")}
          isChecked={preferences.eventRemindersEnabled}
          isDisabled={false}
          accessibilityLabel={t`Toggle event reminder notifications`}
        />
      </HStack>
    </VStack>
  );
};
